import Austria from './AustriaFlagIcon';
import Belgium from './BelgiumFlagIcon';
import Bulgaria from './BulgariaFlagIcon';
import Croatia from './CroatiaFlagIcon';
import Cyprus from './CyprusFlagIcon';
import CzechRepublic from './CzechRepublicFlagIcon';
import Denmark from './DenmarkFlagIcon';
import Dutch from './DutchFlagIcon';
import Finland from './FinlandFlagIcon';
import France from './FranceFlagIcon';
import Germany from './GermanyFlagIcon';
import GreatBritain from './GreatBritainFlagIcon';
import Hungary from './HungaryFlagIcon';
import RepublicOfIreland from './RepublicOfIrelandFlagIcon';
import Italy from './ItalyFlagIcon';
import Luxembourg from './LuxembourgFlagIcon';
import Malta from './MaltaFlagIcon';
import Norway from './NorwayFlagIcon';
import Poland from './PolandFlagIcon';
import Portugal from './PortugalFlagIcon';
import Romania from './RomaniaFlagIcon';
import Slovakia from './SlovakiaFlagIcon';
import Slovenia from './SloveniaFlagIcon';
import Spain from './SpainFlagIcon';
import Sweden from './SwedenFlagIcon';

export const FlagIcon = {
    Austria,
    Belgium,
    Bulgaria,
    Croatia,
    Cyprus,
    CzechRepublic,
    Denmark,
    Dutch,
    Finland,
    France,
    Germany,
    GreatBritain,
    Hungary,
    RepublicOfIreland,
    Italy,
    Luxembourg,
    Malta,
    Norway,
    Poland,
    Portugal,
    Romania,
    Slovakia,
    Slovenia,
    Spain,
    Sweden,
}
